import { keyframes } from "@emotion/react";

export const slotChip = {
  color: "#3A3A3A",
  fontSize: "12px",
  p: "1px 2px",
  m: 0,
  height: "18px",
  cursor: "pointer",
  backgroundColor: "#EAF2F4",
  fontFamily: "Lato",
  "&:hover": {
    // backgroundColor: "neutral.main !important",
    // backgroundColor: "#f58633 !important",
    backgroundColor: "#007A99 !important", // blue
    color: "white !important",
    // border: "1px solid #f58633 !important",
    transition: "background-color 0.4s",
  },
};

export const activeChip = {
  // border: "1px solid #f58633",
  color: "neutral.white",
  fontSize: "12px",
  p: "1px 6px",
  m: 0,
  height: "18px",
  border: "none",
  fontFamily: "Lato",
  "&:hover": {
    backgroundColor: "#007A99 ! important",
    cursor: "pointer",
    color: "white",
  },
  cursor: "pointer",
  // backgroundColor: "neutral.main",
  // backgroundColor: "#f58633",
  backgroundColor: "#007A99",
};

export const textfieldTextPrep = {
  //  padding: "10px 0px",
  fontSize: "14px",
  fontFamily: "Lato",
  transition: "all 0.4s ease-in-out",
  "& .MuiOutlinedInput-root": {
    fontFamily: "Lato",
    borderRadius: "8px",
    height: "40px",
    padding: "9px !important",
    "& input": {
      padding: "4px",
      fontSize: "14px",
    },
  },
  "& .MuiInputBase-root": {
    backgroundColor: "neutral.white",
    transition: "background-color 0.3s",
  },
  "& .MuiInputBase-root.Mui-focused": {
    backgroundColor: "neutral.white",
    // boxShadow:
    //   'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em',
  },
  "& fieldset": {
    border: "neutral.blackBorder", // Remove default border
  },
  "&:hover fieldset": {
    border: "neutral.black", // Remove border on hover
  },
};

export const textfieldTextBlueBorder = {
  //  padding: "10px 0px",
  fontSize: "14px",
  "& .MuiOutlinedInput-root": {
    fontFamily: "Outfit",
    borderRadius: "8px",
    height: "40px",
    padding: "9px !important",
    "& input": {
      padding: "4px",
      fontSize: "14px",
    },
  },
  "& .MuiInputBase-root": {
    backgroundColor: "neutral.white",
    transition: "background-color 0.3s",
  },
  "& .MuiInputBase-root.Mui-focused": {
    backgroundColor: "neutral.white",
  },
  // "& fieldset": {
  //   border: "none", // Remove default border
  // },
  // "&:hover fieldset": {
  //   border: "none", // Remove border on hover
  // },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "neutral.teal", // Blue border color
    borderWidth: "1px", // Border thickness
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "neutral.teal", // Blue border color on hover
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "neutral.teal", // Blue border color when focused
  },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "neutral.teal", // Keep the blue border even when disabled
    // opacity: 1, // Optional: Adjust opacity for a muted effect
  },
  "& fieldset": {
    borderColor: "neutral.teal", // Blue border color
  },
  // Additional styles for hover and focus states
  "&:hover fieldset": {
    borderColor: "neutral.teal",
  },
  "&.Mui-focused fieldset": {
    borderColor: "neutral.teal",
  },
  // Ensure disabled border remains blue
  "&.Mui-disabled fieldset": {
    borderColor: "neutral.teal",
  },
};

export const selectFieldPrep = {
  padding: "9px 0px",
  fontSize: "14px",
  fontFamily: "Lato",
  borderRadius: "8px",
  backgroundColor: "white",
  "& .MuiSelect-select": {
    height: "100%",
    paddingTop: 0,
    paddingBottom: 0,
  },
  "&.Mui-focused": {
    backgroundColor: "white",
    // border:'1px solid grey',
    // boxShadow:
    //   "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
  },
  "&.MuiSelect-select.Mui-focused": {
    backgroundColor: "white",
    // boxShadow:
    //   // "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    //   "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
  },
  "& fieldset": {
    border: "neutral.blackBorder", // Remove default border
  },
  "&:hover fieldset": {
    border: "neutral.black", // Remove border on hover
  },
};

export const dateFiledPrep = {
  marginTop: "2px",
  "& .MuiOutlinedInput-root": {
    height: "38px",
    fontFamily: "Lato",
    borderRadius: "8px",
    fontSize: "14px",
    "& input": {
      padding: "8px",
      fontSize: "14px",
    },
  },
  "& .MuiInputBase-root": {
    backgroundColor: "white",
    transition: "background-color 0.3s",
  },
  "& .MuiInputBase-root.Mui-focused": {
    backgroundColor: "white",
    boxShadow:
      "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
  },
  "& fieldset": {
    border: "none", // Remove default border
  },
  "&:hover fieldset": {
    border: "none", // Remove border on hover
  },
};

export const primaryBtnPrep = {
  backgroundColor: "neutral.main",
  p: 0.5,
  m: 0,
  fontSize: "12px",
  textTransform: "capitalize",
  fontFamily: "Lato",
  "&:hover": {
    backgroundColor: "neutral.main",
    color: "neutral.black",
  },
};

export const dialogBoxSaveBtn = {
  textTransform: "capitalize",
  p: "2px",
  backgroundColor: "neutral.white",
  mt: "2px",
  color: "neutral.black",
  "&:hover": {
    backgroundColor: "neutral.white",
    color: "neutral.black",
  },
};

export const primaryBtnBlue = {
  backgroundColor: "neutral.navyBlue",
  boxShadow:
    "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
  height: "26px",
  p: 2.4,
  fontFamily: "Lato",
  m: 0,
  borderRadius: "20px",
  textTransform: "capitalize",
  transition: "all 0.4s ease-in-out",
  "&:hover": {
    backgroundColor: "#055ee3",
    color: "neutral.white",
    // fontSize:"14.6px",
    // boxShadow: 'rgba(0, 0, 0, 0.15) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px',
    // boxShadow: 'rgba(0, 0, 0, 0.4) 0px 30px 90px',
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 50px",
  },
  "&:active": {
    boxShadow:
      "rgba(0, 0, 0, 0.15) 0px 12px 18px -4px, rgba(0, 0, 0, 0.08) 0px 6px 8px -3px",
    backgroundColor: "#10459c",
  },
};

export const mailBtn = {
  color: "neutral.white",
  backgroundColor: "neutral.teal",
  borderRadius: "8px",
  padding: "3px",
  // width: '90%',
  height: "35px",
  // width: "1.6rem",
  "&:hover": {
    backgroundColor: "#055d72ff",
    color: "neutral.white",
    // fontSize: "15px",
    boxShadow: "rgba(0, 0, 0, 0.4) 0px 30px 90px",
  },
  "&:active": {
    boxShadow:
      "rgba(0, 0, 0, 0.15) 0px 12px 18px -4px, rgba(0, 0, 0, 0.08) 0px 6px 8px -3px",
    backgroundColor: "#055d72ff",
  },
};

export const blueLightBtn = {
  backgroundColor: "neutral.blue1",
  "&:hover": { backgroundColor: "neutral.blue1" },
};

export const orangeButton = {
  backgroundColor: "#1FC16B",
  padding: "0px",
  borderRadius: "50%",
  "&:hover": { backgroundColor: "#16a459ff" },
};

export const primaryBtnTeal = {
  backgroundColor: "neutral.tealButton",
  boxShadow:
    "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
  height: "28px",
  p: 2.4,
  fontSize: "15px",
  alignItems: "center",
  fontFamily: "Lato",
  m: 0,
  borderRadius: "8px",
  textTransform: "capitalize",
  color: "white",
  transition: "all 0.4s ease-in-out",
  border: "2px solid #007A99",
  "&:hover": {
    border: "2px solid #055d72ff",
    backgroundColor: "#055f75ff",
    color: "neutral.white",
    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px',
  },
  "&:active": {
    border: "2px solid #055d72ff",
    boxShadow:
      "rgba(0, 0, 0, 0.15) 0px 12px 18px -4px, rgba(0, 0, 0, 0.08) 0px 6px 8px -3px",
    backgroundColor: "#055d72ff",
  },
  "&:disabled": {
    backgroundColor: "#b0bec5", // muted gray
    border: "2px solid #b0bec5",
    color: "#eeeeee",
    boxShadow: "none",
    cursor: "not-allowed",
    opacity: 0.7,
  },
};

export const selectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    fontFamily: "Lato",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 999999,
  }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "neutral.teal" : "rgba(56, 163, 185, 0.3)",
    boxShadow: state.isFocused ? "0 0 0 1px #2b847eff" : "none",
    "&:hover": {
      borderColor: "rgba(46,55,164,0.3)",
    },
    borderRadius: "8px",
    fontSize: "14px",
    minHeight: "45px",
    fontFamily: "Lato",
  }),

  /** ✅ MENU ITEMS (OPTIONS) STYLE */
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Lato",
    fontSize: "14px",
    padding: "10px 12px",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#9fd8d8ff"
      : state.isFocused
        ? "rgba(43, 132, 126, 0.1)"
        : "#fff",
    color: state.isSelected ? "#302c2c" : "#333",
    "&:active": {
      backgroundColor: "#9fd8d8ff",
      color: "#352f2f",
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#2b847e",
    "&:hover": {
      color: "#1f6d68",
    },
  }),
};

export const rotateSpinner = keyframes`
0% { transform: rotate(0deg); }
10% { transform: rotate(36deg); }
20% { transform: rotate(72deg); }
30% { transform: rotate(108deg); }
40% { transform: rotate(144deg); }
50% { transform: rotate(180deg); }
60% { transform: rotate(216deg); }
70% { transform: rotate(252deg); }
80% { transform: rotate(288deg); }
90% { transform: rotate(324deg); }
100% { transform: rotate(360deg); }
`;
